import React from 'react';
import { Stack, Typography } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { IEvent } from '../../types/global/helper';
import { ChecklistRtl } from '@mui/icons-material';
import { TextWithIcon } from '../TextWithIcon/TextWithIcon';

export interface IEventDetails {
    event: IEvent;
}

const EventRequirements: React.FC<IEventDetails> = ({ event }) => {
    const { themeStyle } = useThemeContext();

    return (
        <Stack>
            <Stack mt={2} mb={4}>
                <TextWithIcon
                    icon={
                        <ChecklistRtl
                            sx={{
                                color: theme[themeStyle].tag_white,
                            }}
                            height={'20px'}
                            width={'20px'}
                        />
                    }
                    text="Requirements"
                />
                {event?.requirements && (
                    <ul style={{ paddingLeft: '20px', marginTop: '10px', color: theme[themeStyle].tag_white }}>
                        {event.requirements.map((requirement, index) => (
                            <li key={index} style={{ marginBottom: '8px' }}>
                                <Typography
                                    sx={{
                                        color: theme[themeStyle].tag_white,
                                        fontSize: 14,
                                        fontFamily: 'inherit',
                                    }}>
                                    {requirement}
                                </Typography>
                            </li>
                        ))}
                    </ul>
                )}
            </Stack>
        </Stack>
    );
};

export { EventRequirements };
